import { useEffect } from 'react';
import { queueNotice } from '../components/Notice';

const onOffline = () => {
  queueNotice({ message: 'Offline.Message' });
};

export function useOffline() {
  useEffect(() => {
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('offline', onOffline);
    };
  }, []);
}
